export default "__VITE_ASSET__10RzFSnc__"